import { useState } from 'react'
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { FormattedMessage } from 'react-intl';
import { useStyletron } from 'baseui';
import { Block } from 'baseui/block';
import { HorizontalStackPanel } from '../../../components/Layout/StackPanel';

export type SensorRangeConfigProps = {
    rangeMin?: number,
    rangeMax?: number,
    dimension: string,
    onRangeMinChanged: any,
    onRangeMaxChanged: any,
    errorMin?: string,
    errorMax?: string,
}

const SensorRangeConfig = ({ rangeMin, rangeMax, dimension, onRangeMinChanged, onRangeMaxChanged, errorMin, errorMax }: SensorRangeConfigProps) => {

    const [css, theme] = useStyletron();
    return (
        <>
            <FormControl
                label={<FormattedMessage id="Devices.SensorRange" defaultMessage="Sensor Range" />}
                error={errorMin && JSON.stringify(errorMin)}
            >
                <HorizontalStackPanel $width={'100%'}>
                    <Input startEnhancer={<FormattedMessage id="Devices.Low" defaultMessage="Low" />}
                        value={rangeMin}
                        onChange={onRangeMinChanged}
                        type='number'
                        error={errorMin ? true : false}
                        endEnhancer={dimension}
                    />
                    <Input startEnhancer={<FormattedMessage id="Devices.High" defaultMessage="High" />}
                        value={rangeMax}
                        onChange={onRangeMaxChanged}
                        error={errorMax ? true : false}
                        type='number'
                        endEnhancer={dimension}
                    />
                </HorizontalStackPanel>
            </FormControl>

        </>
    );
}

export default SensorRangeConfig;
